import router from "@/router"
import api from "../apiService"

class AuthService {
    isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

    check() {
      console.log('check');

      let router_item = { path: '/pages/login', query: { to: router.currentRoute.path } };

      api.auth(false, 'check', null, (res) => {
        this.isLoggedIn = res.msg == 'check ok, connected';
        localStorage.setItem("isLoggedIn", this.isLoggedIn);
        console.log("check this.isLoggedIn", this.isLoggedIn);
        if (!this.isLoggedIn) {
            router.push(router_item);
        }
      });
    }

    login(name, pass, remember) {
      console.log("login", name, pass, remember);

      api.auth(true, 'login', { name, pass }, (res) => {
        this.isLoggedIn = res.success;
        localStorage.setItem("isLoggedIn", this.isLoggedIn);
        console.log("login this.isLoggedIn", this.isLoggedIn);
        if (res.success) {
          api.emitNotifyEvent({
            // title: 'Вход',
            text: "Вход выполнен успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
          router.push(router.currentRoute.query.to || '/');
        } else {
          api.emitNotifyEvent({
            text: "Неверный логин или пароль. Повторите еще раз.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    }

    logout() {
      console.log("logout");

      api.auth(true, 'logout', null, (res) => {
        this.isLoggedIn = false;
        localStorage.setItem("isLoggedIn", this.isLoggedIn);
        console.log("logout this.isLoggedIn", this.isLoggedIn);
        router.push({ path: '/pages/login', query: { to: router.currentRoute.path } });
        if (res.success) {
          api.emitNotifyEvent({
            text: "Выход выполнен успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            text: "Ошибка выхода. Повторите еще раз.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    }

    getLoggedIn() {
      return this.isLoggedIn;
    }
}

export default new AuthService();
